"use client";

import { useEffect, useState } from "react";

import { formatWhatsAppDateLabel } from "@/utils/whatsAppDateLabel";

/**
 * The date chip at the top of the WhatsApp thread. As a little easter egg it
 * always shows the visitor's actual "today". The server-rendered value can be
 * stale (static builds, timezones), so it re-resolves after hydration —
 * hence `suppressHydrationWarning`.
 */
export function WhatsAppDateLabel({ lang }: Readonly<{ lang: string }>) {
  const [label, setLabel] = useState(() => formatWhatsAppDateLabel(lang));

  useEffect(() => {
    setLabel(formatWhatsAppDateLabel(lang));
  }, [lang]);

  return (
    <span
      suppressHydrationWarning
      className="inline-block rounded-md bg-white/80 px-2 py-0.5 text-[0.5625rem] text-black/70 shadow-sm"
    >
      {label}
    </span>
  );
}
